import { renderCellExpand } from "../../components/CellExpandPopup/CellExpandPopup";

export const setValueInParamsToRenderInCell = (params, value) => {
  params.value = value || "";
  return renderCellExpand(params);
};
